import Avatar from "@general-ui/avatar/avatar";
import { useMemo, useRef } from "react";
import { BLAdmin, EPermissions, IReturnableActivity } from "types/working-model";
import { timeSinceAdmin } from "utils/utils";
import { parseUserFromActivity } from "./utils";
import { OptionalComponent } from "utils/optional-component";
import AccessRow from "@admin/settings/access-row-v2";
import { AuthWrapper } from "@admin/authentication/AuthWrapper";

interface Props {
	activityLog: IReturnableActivity;
	adminMap: Map<number, BLAdmin>;
	onClickRestore?: (item: IReturnableActivity) => void;
	allowRevert?: boolean;
	restoring?: boolean;
}

export default function ActivtyLogRow({ activityLog, adminMap, onClickRestore, allowRevert, restoring }: Props) {
	const selfRef = useRef(activityLog);
	const {
		name,
		picture,
		initials
	} = useMemo(() => {
		return parseUserFromActivity(activityLog, adminMap);
	}, [activityLog, adminMap]);

	return useMemo(() => {
		if (activityLog.action === 'Published on') {
			return (
				<div className="activity-log-published-row">
					<span>Published on {new Date(activityLog.timestamp).toLocaleString()} by {name}</span>
					<AuthWrapper allowedRoles={[EPermissions.GroupAdmin, EPermissions.Builder]}>
						<OptionalComponent display={allowRevert}>
							<button className="x-small" disabled={restoring} onClick={() => onClickRestore?.(selfRef.current)}>Restore</button>
						</OptionalComponent>
					</AuthWrapper>
				</div>
			);
		}
		return (
			<div className="activity-log-row">
				<Avatar
					imageUrl={picture}
					initials={initials}
				/>
				<div className="activity-log-row-data">
					<label>
						<span className="name">{name}</span>&nbsp;
						{activityLog.action}&nbsp;
						<span className="name">{activityLog.name}</span>
					</label>
					<time>{timeSinceAdmin(activityLog.timestamp)}</time>
				</div>
			</div>
		);
	}, [activityLog.action, activityLog.name, activityLog.timestamp, picture, initials, name, allowRevert, restoring, onClickRestore]);
}